import { LoaderCircle } from 'lucide-react';
import { Button } from '../ui/Button.jsx';
import { OfflineBanner } from './OfflineBanner.jsx';
import { NativeSplashReady } from './NativeSplashReady.jsx';

export function NativeSessionLoading({ failed, onRetry }) {
  return (
    // On cold starts retain the launch splash while loading, but release it
    // for errors. After sign-in this screen is visible because it is already hidden.
    <NativeSplashReady ready={failed}>
      <div className="native-app-shell bg-paper text-ink">
        <OfflineBanner />
        <main className="flex-1 flex flex-col items-center justify-center gap-4 px-6 text-center">
          {failed ? (
            <>
              <h1 className="text-xl font-medium">We couldn’t load your account</h1>
              <p>Please check your connection and try again.</p>
              <Button onClick={onRetry}>Retry</Button>
            </>
          ) : (
            <div role="status" className="flex flex-col items-center gap-4">
              <LoaderCircle aria-hidden="true" className="animate-spin motion-reduce:animate-none" size={28} />
              <p>Loading your account…</p>
            </div>
          )}
        </main>
      </div>
    </NativeSplashReady>
  );
}
